import {
  CheckedCheckbox,
  RadioCheckedIcon,
  RadioUncheckedIcon,
  UncheckedCheckbox,
} from '@commenda/icons';
import { cn } from '@commenda/utils';
import React from 'react';

const RadioCardKS = ({
  isActive = false,
  isCheckbox = false,
  heading,
  description,
  details,
  onClick,
  className = '',
  iconClassname = '',
  disabled = false,
  titleClassName = '',
  'data-testid': dataTestId,
}: {
  isActive?: boolean;
  isCheckbox?: boolean;
  heading: string | React.ReactNode;
  description?: string | React.ReactNode;
  details?: string[];
  onClick: () => void;
  className?: string;
  iconClassname?: string;
  disabled?: boolean;
  titleClassName?: string;
  'data-testid'?: string;
}) => {
  const Icon = isCheckbox
    ? isActive
      ? CheckedCheckbox
      : UncheckedCheckbox
    : isActive
      ? RadioCheckedIcon
      : RadioUncheckedIcon;
  return (
    <div
      className={cn(
        'p-4 rounded-xl border border-border-primary flex items-start gap-2 cursor-pointer hover:border-neutral-1 transition-all bg-neutral-7',
        isActive ? 'border-neutral-1' : 'border-stroke-2',
        disabled ? 'opacity-50 cursor-not-allowed bg-bg-disabled-subtle' : '',
        className
      )}
      onClick={disabled ? undefined : onClick}
      data-testid={dataTestId}
    >
      <div className="mt-0.5">
        <Icon className={iconClassname} />
      </div>
      <div className="flex flex-col gap-4 grow">
        <div
          className={cn('flex flex-col gap-1 w-full h-full', titleClassName)}
        >
          {React.isValidElement(heading) ? (
            heading
          ) : (
            <h5 className="text-neutral-1">{heading}</h5>
          )}
          {description ? (
            React.isValidElement(description) ? (
              description
            ) : (
              <p className="body-15-regular text-neutral-2">{description}</p>
            )
          ) : null}
        </div>
        {details?.length ? (
          <ul className="flex flex-col gap-2 body-15-regular text-neutral-3 list-disc ml-4">
            {details.map((detail) => (
              <li key={detail}>{detail}</li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
};

export default RadioCardKS;
